import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

export const descriptionStyle = style({
  maxWidth: rem(900),
  margin: "0 auto",
});

export const plusHeadingStyle = style({
  paddingRight: theme.spacings.xl,
  maxWidth: rem(420),
});

export const observationsGridStyle = style({
  gap: theme.spacings.s,
  gridTemplateColumns: "repeat(2, 1fr)",
  ...responsiveContainer({
    800: {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  }),
});
